import React from 'react';
import puzzlePlanetLogo from '../images/logos/title.webp';
import spaceImage from '../images/space.webp';

const TrialSignupSuccess: React.FC = () => {
    return (
        <div
            className='min-h-screen flex flex-col items-center justify-center py-12 px-4 overflow-x-hidden w-full'
            style={{
                backgroundImage: `url(${spaceImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <div className='flex flex-col items-center space-y-8 max-w-2xl w-full'>
                {/* Title Logo */}
                <div className='flex justify-center mb-8'>
                    <img
                        src={puzzlePlanetLogo}
                        alt='Puzzle Planet'
                        className='h-24 md:h-32 w-auto'
                    />
                </div>

                <div className='max-w-md w-full mx-auto p-8 bg-white rounded-2xl shadow-xl border border-gray-100 text-center'>
                    <div className='mb-6'>
                        <div className='w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4'>
                            <svg
                                className='w-8 h-8 text-green-600'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth='2'
                                    d='M5 13l4 4L19 7'
                                ></path>
                            </svg>
                        </div>
                    </div>
                    <h2 className='text-2xl font-bold mb-2' style={{ color: '#FFB502' }}>
                        Trial Activated!
                    </h2>
                    <p className='text-gray-600 mb-6'>
                        Your {import.meta.env.VITE_STRIPE_SIGNUPS_ENABLED === 'true' ? 3 : 7}-day
                        free trial has been activated successfully. Welcome to Puzzle Planet!
                    </p>
                    <button
                        onClick={() => (window.location.href = '/game?t=' + new Date().getTime())}
                        className='w-full px-8 py-4 text-lg font-semibold bg-gradient-to-b from-yellow-400 to-orange-500 text-black rounded-lg hover:from-yellow-500 hover:to-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 transform transition-all duration-200'
                    >
                        Start Playing
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TrialSignupSuccess;
